var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89615 1.34C2.6474 1.60375 2.49989 2.01125 2.49989 2.54125V21.4575C2.49989 21.9875 2.6474 22.3963 2.89615 22.6588L2.9599 22.72L13.5562 12.125V12V11.875L2.95865 1.2775L2.89615 1.34Z",
    fill: "url(#paint0_linear_109_889)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0875 15.6587L13.5563 12.125V12V11.875L17.0887 8.34253L17.1688 8.38753L21.3538 10.765C22.5487 11.4437 22.5487 12.555 21.3538 13.235L17.1688 15.6125L17.0875 15.6587Z",
    fill: "url(#paint1_linear_109_889)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1688 15.6125L13.5563 12L2.89629 22.66C3.29004 23.0775 3.94128 23.1287 4.67379 22.7125L17.1688 15.6125Z",
    fill: "url(#paint2_linear_109_889)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1688 8.38753L4.67379 1.28752C3.94128 0.871271 3.29004 0.922523 2.89629 1.34002L13.5563 12L17.1688 8.38753Z",
    fill: "url(#paint3_linear_109_889)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.0888 15.5338L4.67379 22.5875C3.97879 22.9825 3.35878 22.9563 2.96004 22.5963L2.89629 22.66L2.96004 22.7213C3.35878 23.08 3.97879 23.1076 4.67379 22.7125L17.1688 15.6125L17.0888 15.5338Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M2.89615 22.5351C2.6474 22.2713 2.49989 21.8626 2.49989 21.3338V21.4588C2.49989 21.9889 2.6474 22.3976 2.89615 22.6601L2.9599 22.5964L2.89615 22.5351Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M21.3536 13.11L17.0886 15.5338L17.1686 15.6137L21.3536 13.2362C21.9511 12.8962 22.2499 12.4487 22.2499 12.0013C22.1998 12.405 21.8948 12.8025 21.3536 13.11Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M4.67365 1.4125L21.3536 10.89C21.8962 11.1975 22.1999 11.595 22.2499 12C22.2499 11.5525 21.9511 11.105 21.3536 10.765L4.67365 1.2875C3.4774 0.608755 2.49989 1.1725 2.49989 2.54251V2.6675C2.49989 1.29751 3.4774 0.733753 4.67365 1.4125Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_889",
    x1: 12.6161,
    y1: 2.34221,
    x2: -1.73853,
    y2: 16.6968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_109_889",
    x1: 22.9097,
    y1: 12.0003,
    x2: 2.21326,
    y2: 12.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_109_889",
    x1: 15.2054,
    y1: 13.9631,
    x2: -4.26055,
    y2: 33.4291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_109_889",
    x1: 0.211735,
    y1: -4.95676,
    x2: 8.90405,
    y2: 3.73558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGooglePlay);
export default __webpack_public_path__ + "static/media/icon_google_play.d3b9b91907a38b92d349fb777006de89.svg";
export { ForwardRef as ReactComponent };